export default "/images/green@2x.png?8fb569a4e2458136e099626ada9b7fd7";